"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * datAIndustry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametersApi = exports.ParametersApiFactory = exports.ParametersApiFp = exports.ParametersApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * ParametersApi - axios parameter creator
 * @export
 */
exports.ParametersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a new parameter
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParameter: function (parameter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameter' is not null or undefined
                            common_1.assertParamExists('addParameter', 'parameter', parameter);
                            localVarPath = "/parameters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(parameter, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a parameter
         * @param {number} paramId The id of the parameter to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: function (paramId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'paramId' is not null or undefined
                            common_1.assertParamExists('deleteParameter', 'paramId', paramId);
                            localVarPath = "/parameters/{paramId}"
                                .replace("{" + "paramId" + "}", encodeURIComponent(String(paramId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Export machine parameters
         * @param {number} machineId The id of the machine for which the parameters should be exported
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportParameters: function (machineId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            common_1.assertParamExists('exportParameters', 'machineId', machineId);
                            localVarPath = "/parameters/export";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (machineId !== undefined) {
                                localVarQueryParameter['machineId'] = machineId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a parameter
         * @param {number} paramId The id of the parameter to be retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: function (paramId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'paramId' is not null or undefined
                            common_1.assertParamExists('getParameter', 'paramId', paramId);
                            localVarPath = "/parameters/{paramId}"
                                .replace("{" + "paramId" + "}", encodeURIComponent(String(paramId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Import machine parameters
         * @param {number} machineId The id of the machine for which the parameters should be imported
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importParameters: function (machineId, file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            common_1.assertParamExists('importParameters', 'machineId', machineId);
                            // verify required parameter 'file' is not null or undefined
                            common_1.assertParamExists('importParameters', 'file', file);
                            localVarPath = "/parameters/import";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (machineId !== undefined) {
                                localVarQueryParameter['machineId'] = machineId;
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all parameters
         * @param {number} [machineId] The id of the machine for which the parameters should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameters: function (machineId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/parameters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (machineId !== undefined) {
                                localVarQueryParameter['machineId'] = machineId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a parameter
         * @param {number} paramId The id of the parameter to be updated
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameter: function (paramId, parameter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'paramId' is not null or undefined
                            common_1.assertParamExists('updateParameter', 'paramId', paramId);
                            // verify required parameter 'parameter' is not null or undefined
                            common_1.assertParamExists('updateParameter', 'parameter', parameter);
                            localVarPath = "/parameters/{paramId}"
                                .replace("{" + "paramId" + "}", encodeURIComponent(String(paramId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, common_1.setBearerAuthToObject(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(parameter, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ParametersApi - functional programming interface
 * @export
 */
exports.ParametersApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ParametersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new parameter
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParameter: function (parameter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addParameter(parameter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a parameter
         * @param {number} paramId The id of the parameter to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: function (paramId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteParameter(paramId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Export machine parameters
         * @param {number} machineId The id of the machine for which the parameters should be exported
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportParameters: function (machineId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.exportParameters(machineId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a parameter
         * @param {number} paramId The id of the parameter to be retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: function (paramId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParameter(paramId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Import machine parameters
         * @param {number} machineId The id of the machine for which the parameters should be imported
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importParameters: function (machineId, file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importParameters(machineId, file, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all parameters
         * @param {number} [machineId] The id of the machine for which the parameters should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameters: function (machineId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listParameters(machineId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a parameter
         * @param {number} paramId The id of the parameter to be updated
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameter: function (paramId, parameter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateParameter(paramId, parameter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ParametersApi - factory interface
 * @export
 */
exports.ParametersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ParametersApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new parameter
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParameter: function (parameter, options) {
            return localVarFp.addParameter(parameter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a parameter
         * @param {number} paramId The id of the parameter to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: function (paramId, options) {
            return localVarFp.deleteParameter(paramId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Export machine parameters
         * @param {number} machineId The id of the machine for which the parameters should be exported
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportParameters: function (machineId, options) {
            return localVarFp.exportParameters(machineId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a parameter
         * @param {number} paramId The id of the parameter to be retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: function (paramId, options) {
            return localVarFp.getParameter(paramId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Import machine parameters
         * @param {number} machineId The id of the machine for which the parameters should be imported
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importParameters: function (machineId, file, options) {
            return localVarFp.importParameters(machineId, file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all parameters
         * @param {number} [machineId] The id of the machine for which the parameters should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParameters: function (machineId, options) {
            return localVarFp.listParameters(machineId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a parameter
         * @param {number} paramId The id of the parameter to be updated
         * @param {Parameter} parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParameter: function (paramId, parameter, options) {
            return localVarFp.updateParameter(paramId, parameter, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ParametersApi - object-oriented interface
 * @export
 * @class ParametersApi
 * @extends {BaseAPI}
 */
var ParametersApi = /** @class */ (function (_super) {
    __extends(ParametersApi, _super);
    function ParametersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a new parameter
     * @param {Parameter} parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.addParameter = function (parameter, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).addParameter(parameter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a parameter
     * @param {number} paramId The id of the parameter to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.deleteParameter = function (paramId, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).deleteParameter(paramId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Export machine parameters
     * @param {number} machineId The id of the machine for which the parameters should be exported
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.exportParameters = function (machineId, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).exportParameters(machineId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a parameter
     * @param {number} paramId The id of the parameter to be retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.getParameter = function (paramId, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).getParameter(paramId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Import machine parameters
     * @param {number} machineId The id of the machine for which the parameters should be imported
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.importParameters = function (machineId, file, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).importParameters(machineId, file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all parameters
     * @param {number} [machineId] The id of the machine for which the parameters should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.listParameters = function (machineId, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).listParameters(machineId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a parameter
     * @param {number} paramId The id of the parameter to be updated
     * @param {Parameter} parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.updateParameter = function (paramId, parameter, options) {
        var _this = this;
        return exports.ParametersApiFp(this.configuration).updateParameter(paramId, parameter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ParametersApi;
}(base_1.BaseAPI));
exports.ParametersApi = ParametersApi;
